import { render, staticRenderFns } from "./FGDictRenderer.vue?vue&type=template&id=1f1f2716"
import script from "./FGDictRenderer.vue?vue&type=script&lang=js"
export * from "./FGDictRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports